<template>
	<div class="media">
		<x-icon
			size="1.5x"
			class="custom-class"
			@click="removeMedia"
			v-if="editable"
		></x-icon>
		<img
			v-if="getMedia(id)"
			:src="getMedia(id).thumbnail"
			:width="getMedia(id).width"
			:height="getMedia(id).height"
		/>
	</div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { XIcon } from "vue-feather-icons";
export default {
	name: "media",
	components: {
		XIcon,
	},
	props: {
		id: {
			type: Number,
		},
		src: {
			type: String,
			default: null,
		},
		size: {
			type: Number,
			default: 200,
		},
		editable: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({}),
	computed: {
		...mapGetters(["getMedia"]),
		width() {
			return this.size;
		},
		height() {
			return this.size;
		},
	},
	methods: {
		toJSON() {
			return {
				id: this.id,
				src: this.src,
				size: this.size,
			};
		},
		removeMedia() {
			if (
				window.confirm(
					"Etes-vous sur de vouloir supprimer définitivement cette photo ?"
				)
			) {
				this.$store.commit("removeMedia", this.id);
			}
		},
	},
	mounted: function () {
		if (!this.src) {
			// Nova.request()
			//   .get("/nova-mahi-diaporama/media/" + this.id)
			//   .then(response => {
			//     this.src = response.data.src;
			//   });
		}
	},
};
</script>
<style lang="scss">
.media {
	position: relative;
	cursor: grab;
	padding-top: 20px;
	.feather-x {
		position: absolute;
		// top: 0.5rem;
		// right: 1rem;
		// stroke: white;
		// stroke-width: 0.25rem;
		// background: #d22e26;
		// border-radius: 50%;
		// height: 1.25rem;
		// width: 1.25rem;
	}
}
</style>
